const SCHEDULE_CANCELLATION_REASON_LABELS: Record<string, string> = {
    MEMBER_APP_WITHDRAWAL: '앱 회원 탈퇴',
};

export const formatScheduleCancellationReason = (reason?: string | null): string => {
    if (reason == null) {
        return '';
    }

    if (Object.prototype.hasOwnProperty.call(SCHEDULE_CANCELLATION_REASON_LABELS, reason)) {
        return SCHEDULE_CANCELLATION_REASON_LABELS[reason];
    }

    return reason;
};
